export default window.frm.translations;
